<template>
  <div class="pdf-box">
    <pdf ref="pdf" :src="pdfSrc" :page="pageNum" :rotate="pageRotate" @progress="loadedRatio = $event" @page-loaded="pageLoaded($event)" @loaded="loadPDF" @num-pages="pageTotalNum = $event" @error="pdfError($event)" @link-clicked="page = $event"></pdf>
    <div class="tools mb10" v-show="pageTotalNum > 1">
      <el-button type="text" size="small" icon="el-icon-arrow-left" @click.stop="prePage" style="margin-right: 10px;">
      </el-button>
      <div class="page">{{ pageNum }} / {{ pageTotalNum }}</div>
      <el-button type="text" size="small" icon="el-icon-arrow-right" @click.stop="nextPage" style="margin-left: 10px; margin-right: 10px;">
      </el-button>

      <el-button type="default" size="small" @click.stop="clock" class="mr10">
        顺时针
      </el-button>
      <el-button type="default" size="small" @click.stop="counterClock">
        逆时针
      </el-button>
    </div>
  </div>
</template>

<script>
import pdf from "vue-pdf";
import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js' //解决中文显示
export default {
  data() {
    return {
      pageNum: 1,
      pageTotalNum: 1,
      pageRotate: 0,
      // 加载进度
      loadedRatio: 0,
      pdfSrc: ""
    }
  },
  props: {
    pdfUrl: {
      type: String,
      default: ""
    }
  },
  components: {
    pdf
  },
  mounted() {
    if (this.pdfUrl)
      this.pdfSrc = pdf.createLoadingTask({ url: this.pdfUrl, CMapReaderFactory })
  },
  methods: {
    // 上一页函数，
    prePage() {
      var page = this.pageNum;
      page = page > 1 ? page - 1 : this.pageTotalNum;
      this.pageNum = page;
      window.scrollTo(0, 0);
    },
    // 下一页函数
    nextPage() {
      var page = this.pageNum;
      page = page < this.pageTotalNum ? page + 1 : 1;
      this.pageNum = page;
      window.scrollTo(0, 0);
    },
    // 页面顺时针翻转90度。
    clock() {
      this.pageRotate += 90;
    },
    // 页面逆时针翻转90度。
    counterClock() {
      this.pageRotate -= 90;
    },
    // 页面加载回调函数，其中e为当前页数
    pageLoaded(e) {
      this.pageNum = e;
    },
    loadPDF() {
      this.pageNum = 1;
    },
    // 其他的一些回调函数。
    pdfError(error) {
      console.error(error);
    },
  },
}
</script>

<style lang="less">
.pdf-box {
  padding: 0 16px;
}

.tools {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
}

.nav-bar-content {
  display: flex;
  align-items: center;
  height: 46px;
  line-height: 22px;
  margin-bottom: 16px;
  position: relative;

  .nav-bar-left,
  .nav-bar-right {
    position: absolute;
    top: 0;
    bottom: 0;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    font-size: 14px;
    cursor: pointer;
  }

  .nav-bar-left {
    left: 0;

    i {
      font-size: 16px;
      margin-right: 4px;
    }
  }

  .nav-bar-right {
    right: 0;
  }
}
</style>